/* MARMOT Кампания „Време за училище" - чистата логика на срока и на брояча.

   Изнесена отделно по образеца на marmot-delivery-logic.js: тук НЯМА достъп до
   document/window, само пресмятания, и затова е тестима с `node --test` без
   браузър (UMD: window.MarmotCampaignSchool в браузъра, module.exports в Node).

   ЧАСОВАТА ЗОНА е целият смисъл на този файл. Границите пътуват като ПЪЛНИ
   моменти с изричен офсет - „2026-09-30T23:59:59+03:00", „2026-09-24T00:00:00+03:00" -
   и се четат с Date.parse. Затова резултатът не зависи нито от часовата зона на
   посетителя, нито от тази на сървъра. Наивна сметка в UTC гаси кампанията в
   21:00 UTC на 30 септември, тоест три часа преди края на софийския ден.

   Офсетът +03:00 е EEST и важи до последната неделя на октомври. Кампанията
   свършва на 30 септември, тоест изцяло вътре в летния период. Премести ли се
   краят след смяната на часа, офсетът в настройката се сменя на +02:00. */
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.MarmotCampaignSchool = api;
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var MINUTA = 60000;

  /* Празен, счупен или липсващ момент връща null, а не NaN, който после мълчаливо
     прави всяко сравнение невярно. Викачите проверяват за null изрично. */
  function moment(text) {
    if (typeof text !== 'string') return null;
    var chist = text.trim();
    if (!chist) return null;
    var ms = Date.parse(chist);
    return isFinite(ms) ? ms : null;
  }

  /* Кампанията тече ли в този момент. Границата е ВКЛЮЧВАЩА - краят е
     последната секунда на 30 септември, а не първата на 1 октомври. */
  function vSrok(nowMs, endText) {
    var end = moment(endText);
    if (end === null) return false;
    return nowMs <= end;
  }

  /* Броячът мълчи до 24 септември (раздел 13.5): число „29 дни" изглежда като
     реквизит и не поражда бързане. Появата му сама по себе си е сигналът. */
  function sBroyach(nowMs, endText, fromText) {
    if (!vSrok(nowMs, endText)) return false;
    var from = moment(fromText);
    if (from === null) return false;
    return nowMs >= from;
  }

  /* Дни, часове и минути до края. Извън срока връща null - броячът никога не
     показва отрицателни числа, а изчезва. */
  function ostatak(nowMs, endText) {
    var end = moment(endText);
    if (end === null) return null;
    var razlika = end - nowMs;
    if (razlika < 0) return null;
    var minuti = Math.floor(razlika / MINUTA);
    return {
      days: Math.floor(minuti / 1440),
      hours: Math.floor((minuti % 1440) / 60),
      minutes: minuti % 60
    };
  }

  function duma(broy, edno, mnogo) {
    return broy === 1 ? edno : mnogo;
  }

  function tekstNaBroyacha(rest) {
    if (!rest) return '';
    return 'Остават ' +
      rest.days + ' ' + duma(rest.days, 'ден', 'дни') + ', ' +
      rest.hours + ' ' + duma(rest.hours, 'час', 'часа') + ' и ' +
      rest.minutes + ' ' + duma(rest.minutes, 'минута', 'минути');
  }

  /* Дребният ред на лентата: „избираш от N заглавия".

     Числото го знае само Editera, затова Liquid не го изписва - тази функция
     сглобява частта чак когато каталогът е преброен. Нула или негодна стойност
     връща празен низ, тоест частта остава скрита: „избираш от 0 заглавия" е
     по-лошо от нищо, а кампанията пак се обявява с текста. */
  function tekstZaBroyZaglavia(broy) {
    if (typeof broy !== 'number' || !isFinite(broy) || broy < 1) return '';
    var cyalo = Math.floor(broy);
    return 'избираш от ' + cyalo + ' ' + duma(cyalo, 'заглавие', 'заглавия');
  }

  /* Размерите, които CSS-ът пази в променливи. Тук са, за да ги закове тестът:
     разминат ли се с CSS-а, сметката става вярна за друг екран, не за този.
     Самата подредба вече НЕ ги ползва - тя мери истинската ширина в браузъра,
     защото на телефон корицата е clamp() и зависи от ширината на екрана.

     pole        - .marmot-campaign__inner е max-width: 900px;
     korica      - таванът на clamp(52px, 11vw, 78px);
     otstap      - --marmot-space-sm, отстоянието на широк екран;
     minKorica   - под тази ширина корицата не се свива (виж podredbaOtMyarka);
     luft        - луфт срещу закръгляне. */
  var RAZMERI = { pole: 900, korica: 78, otstap: 8, luft: 4, minKorica: 40 };

  /* Колко корици се събират в дадена ширина. n корици заемат
     n * korica + (n - 1) * otstap, тоест обратното е цялата част от
     (shirina + otstap) / (korica + otstap). */
  function koriciVShirina(shirina, korica, otstap) {
    if (!(shirina > 0) || !(korica > 0) || !(otstap >= 0)) return 0;
    var n = Math.floor((shirina + otstap) / (korica + otstap));
    return n > 0 ? n : 0;
  }

  /* Обратната сметка: колко широк да е редът, за да побере точно naRed корици.
     Същият израз стои и в CSS-а през променливи; тестът смята този и онзи и ги
     сравнява, за да не може единият да се промени без другия. */
  function shirinaZaRed(naRed, korica, otstap, luft) {
    if (!(naRed > 0) || !(korica > 0) || !(otstap >= 0)) return 0;
    return naRed * korica + (naRed - 1) * otstap + (luft > 0 ? luft : 0);
  }

  /* Колко корици стоят на ПЪРВИЯ ред.

     Взима броя заглавия и колко от тях се събират в реда (`fits`, измерено в
     браузъра). Решението е тук, а не в CSS-а, защото зависи от БРОЯ, а CSS не
     умее да брои елементи.

     Две правила, в този ред:

     1. РАВНИ РЕДОВЕ. Редът беше авто и вземаше колкото се съберат: 13 заглавия
        падаха като 10 + 3 на десктоп и като 6 + 6 + 1 на телефон. Тук първо се
        смята на колко реда ще се падне при пълни редове, а после броят се
        разделя по равно между тях: 13 при fits 10 -> 2 реда -> 7 + 6.

     2. БЕЗ САМОТНА КОРИЦА. Ако при така избраното число последният ред остава
        с ЕДНА корица, числото слиза, докато това спре. 13 при fits 6 дава
        балансирано 5 -> 5 + 5 + 3, а не 6 + 6 + 1.

     Има случаи без решение: при fits 4 и 13 корици всяко число дава остатък 1
     (13 = 4+4+4+1 = 3+3+3+3+1 = 2·6+1). Тогава тук се връща балансираното
     число - по-добре една самотна корица, отколкото тринайсет реда по една -
     а изходът се търси от podredbaOtMyarka, като свие корицата, за да се
     събере още една.

     Нулев или негоден вход връща 0, тоест „не знам" - викачът тогава не пипа
     нищо и CSS-ът остава с подразбирането си. */
  function koriciNaRed(broy, fits) {
    if (typeof broy !== 'number' || !isFinite(broy) || broy < 1) return 0;
    if (typeof fits !== 'number' || !isFinite(fits) || fits < 1) return 0;
    var cyalo = Math.floor(broy);
    var pobira = Math.floor(fits);
    if (cyalo <= pobira) return cyalo;

    var redove = Math.ceil(cyalo / pobira);
    var balansirano = Math.ceil(cyalo / redove);

    var kandidat = balansirano;
    while (kandidat >= 2 && cyalo % kandidat === 1) kandidat -= 1;
    return kandidat >= 2 ? kandidat : balansirano;
  }

  /* Цялото решение за подредбата, взето от ИЗМЕРЕНИ стойности.

     Тук е, а не в браузърния файл, защото това е решението - кое число отива в
     CSS-а и трябва ли корицата да се свие. Браузърният файл само мери и подава;
     така решението се тества без браузър, вместо да се проверява дали изходният
     му текст съдържа правилните думи.

     Връща null при негодна мярка (нула, NaN, откачен от DOM възел). Викачът
     тогава НЕ пипа нищо - по-добре предишната подредба, отколкото подредба от
     мярка, която не значи нищо.

     Свиването на корицата е последната стъпка и се прави само когато няма друг
     изход. При много тесен екран в реда се събират 4 корици, а 13 по 4 винаги
     свършват със самотна - и същото важи за 3 и за 2, тоест числото няма къде
     да слезе. Тогава корицата се свива точно колкото да се събере още една, и
     подредбата става 5 + 5 + 3. Сметката не се върти в кръг: полето не зависи
     от ширината на корицата, тоест свиването не мени входа си.

     На истински телефон това НЕ се задейства: при 390px в реда се събират 6 и
     балансираното число 5 вече няма самотна. Свиването е за прозорец на
     настолен браузър под ~324px, където лентата за скролиране изяжда ширина. */
  function podredbaOtMyarka(broy, pole, korica, otstap) {
    if (typeof broy !== 'number' || !isFinite(broy) || broy < 1) return null;
    if (typeof pole !== 'number' || !isFinite(pole) || pole <= 0) return null;
    if (typeof korica !== 'number' || !isFinite(korica) || korica <= 0) return null;
    if (typeof otstap !== 'number' || !isFinite(otstap) || otstap < 0) return null;

    var cyalo = Math.floor(broy);
    var pobira = koriciVShirina(pole, korica, otstap);
    var naRed = koriciNaRed(cyalo, pobira);
    if (naRed < 1) return null;
    if (cyalo % naRed !== 1) return { naRed: naRed, korica: 0 };

    var celi = pobira + 1;
    var svita = Math.floor((pole - (celi - 1) * otstap) / celi);
    if (!(svita >= RAZMERI.minKorica) || svita >= korica) return { naRed: naRed, korica: 0 };

    var naRed2 = koriciNaRed(cyalo, koriciVShirina(pole, svita, otstap));
    if (naRed2 < 1 || cyalo % naRed2 === 1) return { naRed: naRed, korica: 0 };
    return { naRed: naRed2, korica: svita };
  }

  /* Таванът на ветрилото, прочетен от атрибут. Липсващ, негоден или нулев
     атрибут значи „без таван" (0) - така блокът на началната остава с всичките
     си корици, а лентата в каталога иска 4. Тук е, а не в браузърния файл,
     защото решение, което реже съдържание, трябва да се тества без браузър. */
  function tavan(stoynost) {
    var n = parseInt(stoynost, 10);
    if (!isFinite(n) || n < 1) return 0;
    return n;
  }

  return {
    moment: moment,
    tavan: tavan,
    vSrok: vSrok,
    sBroyach: sBroyach,
    ostatak: ostatak,
    tekstNaBroyacha: tekstNaBroyacha,
    tekstZaBroyZaglavia: tekstZaBroyZaglavia,
    koriciNaRed: koriciNaRed,
    podredbaOtMyarka: podredbaOtMyarka,
    koriciVShirina: koriciVShirina,
    shirinaZaRed: shirinaZaRed,
    razmeri: RAZMERI
  };
});
